import apiClient from './axios-instance'
import { GetLegalDocumentResponse, LegalDocumentType } from '@/lib/types/legal.types'

/**
 * Legal Documents API Service
 * Public endpoints - no authentication required
 */
export const legalApi = {
  /**
   * Get legal document by type
   * @param type - 'privacy_policy' or 'terms_conditions'
   */
  getLegalDocument: async (type: LegalDocumentType): Promise<GetLegalDocumentResponse> => {
    const response = await apiClient.get<GetLegalDocumentResponse>(
      '/legal-documents',
      {
        params: { type },
      }
    )
    return response.data
  },
}

